import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from 'jquery'
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
// export const DropDownCellProduto = props => {
  
var optionsSerieIntervalo = [];
var DropDownCellTipoVasilha = null;
var ProdSelo = null;
var IdIntervalo = null;
var entidadeTiposeloSerie;
function FindProduto(intervalo){
  (async (e) => {
    console.log("NumeroSelo")
    const data = {"IDEntidade": entidadeTiposeloSerie,
                  "Serie": $('#id-SerieSelo')[0].outerText,
                  "Intervalo": intervalo}

    const ProdutoSelo = await services.apiCall.requestApi(
        "/Selos/GetProdutobyIntervalos",
        data,
        "get"
    );
      $(".ProdutoSelos").val(ProdutoSelo.produto)
      ProdSelo = ProdutoSelo.produto;
    console.log(ProdutoSelo);
  })();

}

class DropDownCellIntervalosSelos extends Component {
 
  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
    IdIntervalo = e;    
    console.log(e)
    $('#id-Intervalo-Selo').html(e.value.value);
    $(".NumeroInicial").val("");
    $(".NumeroFinal").val("");
    $(".QuantidadeSelos").val("");
    FindProduto(e.value.text);
    $(".ProdutoSelos").val(ProdSelo)
  }

  static ChangeValueById(id , entidadeSerie){
    entidadeTiposeloSerie = entidadeSerie;
    console.log('DropDownCellIntervalos')
    optionsSerieIntervalo = [];
    (async () => {
      if(id.value.text != undefined){
        var valor = id.value.text
      }else{
        var valor = id.text
      }
      const data = {
        "idEntidade": entidadeTiposeloSerie,
        "Serie":valor
      }

        const Intervalo = await services.apiCall.requestApi(
          "/Selos/GetIntervalosSerie",
          data,
          "get"
        );

        if(Intervalo){
          var indexintervalo = 0
          Intervalo.map((selo) => (
            optionsSerieIntervalo.push({text: selo.intervalo, value: indexintervalo, idRegistoSelo: selo.idRegistoSelo}),
            indexintervalo += 1
          ));     
        }else{
          optionsSerieIntervalo = [];
        };        
    })();

  }

  componentDidMount = () => {

    // myFunction();

  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsSerieIntervalo.length > 0 ? optionsSerieIntervalo.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null)): dataItem.intervalosDisponiveis_selosGarantia}
                data={optionsSerieIntervalo}
                textField="text"
                id='id-Intervalo'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
}

export default DropDownCellIntervalosSelos;